// Static catalog & data for SolveTax clone
import {
  Receipt, FileText, ShieldAlert, Building2, BookOpen, Users, Clock, Sparkles, BadgeCheck,
  Calculator, FilePlus2, FileX2, FileCheck2, FileSignature, RefreshCw, FileWarning,
  TrendingUp, PieChart, Wallet, Briefcase, UserCog, ScrollText, Banknote,
  CalendarRange, IndianRupee, ShieldCheck, Globe2, Flame, Award, Stamp,
} from 'lucide-react';

// =============================================================================
// SERVICE CATALOG  (matches backend codes)
// =============================================================================
export const SERVICE_CATALOG = [
  // GST
  { code: 'GST_REGISTRATION',     category: 'GST',         title: 'GST Registration',          icon: FilePlus2,    desc: 'Get a fresh GSTIN for your business in 3-7 working days.' },
  { code: 'GST_AMENDMENT',        category: 'GST',         title: 'GST Amendment',             icon: FileSignature,desc: 'Update business details, address or partners on GSTIN.' },
  { code: 'GST_CANCELLATION',     category: 'GST',         title: 'GST Cancellation',          icon: FileX2,       desc: 'Officially surrender / cancel your GST registration.' },
  { code: 'GST_FILING',           category: 'GST',         title: 'GST Monthly Filing',        icon: FileCheck2,   desc: 'GSTR-1 & GSTR-3B filed accurately every month.' },
  { code: 'GST_Q_FILING',         category: 'GST',         title: 'GST Quarterly Filing',      icon: CalendarRange,desc: 'QRMP scheme - quarterly GSTR-1 & 3B for small businesses.' },
  { code: 'GST_ANNUAL_RETURN',    category: 'GST',         title: 'GST Annual Return',         icon: ScrollText,   desc: 'GSTR-9 / 9C annual filing with reconciliation.' },
  { code: 'GST_LUT',              category: 'GST',         title: 'GST LUT Filing',            icon: Globe2,       desc: 'Letter of Undertaking for zero-rated exports.' },
  { code: 'GST_REFUND',           category: 'GST',         title: 'GST Refund',                icon: RefreshCw,    desc: 'Claim refund of accumulated ITC / export refunds.' },
  { code: 'GST_NOTICE_REPLY',     category: 'GST',         title: 'GST Notice Reply',          icon: FileWarning,  desc: 'Expert response to GST notices, ASMT-10 & DRC.' },

  // INCOME TAX (uses /api/v1/income-tax)
  { code: 'ITR_FILING',           category: 'INCOME_TAX',  title: 'Income Tax Return Filing',  icon: Receipt,      desc: 'ITR-1 to ITR-7 filed accurately with maximum refund.' },
  { code: 'ITR_NOTICE',           category: 'INCOME_TAX',  title: 'ITR Notice Response',       icon: ShieldAlert,  desc: 'Reply to 139(9), 143(1), 148 & scrutiny notices.' },
  { code: 'ADVANCE_TAX',          category: 'INCOME_TAX',  title: 'Advance Tax Calculation',   icon: Calculator,   desc: 'Quarterly advance tax computation and payment.' },
  { code: 'CAPITAL_GAINS',        category: 'INCOME_TAX',  title: 'Capital Gains Calculation', icon: TrendingUp,   desc: 'Stocks, MFs, property capital gains computation.' },

  // COMPANY
  { code: 'PVT_LTD_REG',          category: 'COMPANY',     title: 'Private Limited Registration', icon: Building2, desc: 'Incorporate a Pvt Ltd company end-to-end.' },
  { code: 'LLP_REG',              category: 'COMPANY',     title: 'LLP Registration',          icon: Briefcase,    desc: 'Limited Liability Partnership formation.' },
  { code: 'OPC_REG',              category: 'COMPANY',     title: 'OPC Registration',          icon: UserCog,      desc: 'One Person Company registration for solo founders.' },
  { code: 'PARTNERSHIP_REG',      category: 'COMPANY',     title: 'Partnership Firm Registration', icon: Users,    desc: 'Traditional partnership firm registration.' },

  // MCA
  { code: 'ROC_ANNUAL',           category: 'MCA',         title: 'ROC Annual Filing',         icon: FileText,     desc: 'AOC-4, MGT-7 annual ROC compliance filings.' },
  { code: 'DIR3_KYC',             category: 'MCA',         title: 'DIR-3 KYC',                 icon: BadgeCheck,   desc: 'Annual KYC of company directors.' },
  { code: 'DIRECTOR_CHANGE',      category: 'MCA',         title: 'Director Change',           icon: UserCog,      desc: 'Add, remove or change directors.' },

  // ACCOUNTING
  { code: 'MONTHLY_ACCOUNTING',   category: 'ACCOUNTING',  title: 'Monthly Accounting',        icon: BookOpen,     desc: 'Bookkeeping, Tally / Zoho with monthly MIS.' },
  { code: 'YEAR_END_FINALIZATION',category: 'ACCOUNTING',  title: 'Year End Finalization',     icon: PieChart,     desc: 'Year-end books closing & financial statements.' },

  // PAYROLL
  { code: 'PAYROLL_PROCESSING',   category: 'PAYROLL',     title: 'Payroll Processing',        icon: Wallet,       desc: 'Salary processing, payslips and statutory compliance.' },
  { code: 'PF_FILING',            category: 'PAYROLL',     title: 'PF Filing',                 icon: Banknote,     desc: 'EPF monthly returns and challan generation.' },
  { code: 'ESI_FILING',           category: 'PAYROLL',     title: 'ESI Filing',                icon: ShieldCheck,  desc: 'Employee State Insurance monthly filings.' },

  // TRADEMARK
  { code: 'TRADEMARK_REG',        category: 'TRADEMARK',   title: 'Trademark Registration',    icon: Stamp,        desc: 'Register your brand / logo as a trademark.' },
  { code: 'TRADEMARK_RENEWAL',    category: 'TRADEMARK',   title: 'Trademark Renewal',         icon: RefreshCw,    desc: 'Renew expiring trademarks before deadline.' },

  // LICENSE
  { code: 'MSME_REG',             category: 'LICENSE',     title: 'MSME / Udyam Registration', icon: Award,        desc: 'Free Udyam registration for MSMEs.' },
  { code: 'FSSAI_LICENSE',        category: 'LICENSE',     title: 'FSSAI License',             icon: Flame,        desc: 'Food business license - basic, state, central.' },
  { code: 'IEC_REG',              category: 'LICENSE',     title: 'Import Export Code',        icon: IndianRupee,  desc: 'IEC code for cross-border business.' },
];

export const CATEGORY_META = {
  GST:         { label: 'GST',                  desc: 'Registration, monthly filings, refunds & notices' },
  INCOME_TAX:  { label: 'Income Tax',           desc: 'ITR filing, notices, advance tax & capital gains' },
  COMPANY:     { label: 'Company Registration', desc: 'Pvt Ltd, LLP, OPC and Partnership formations' },
  MCA:         { label: 'MCA / ROC',            desc: 'Annual filings, KYC and director changes' },
  ACCOUNTING:  { label: 'Accounting',           desc: 'Bookkeeping, MIS and year-end closing' },
  PAYROLL:     { label: 'Payroll',              desc: 'Salary processing, PF and ESI compliance' },
  TRADEMARK:   { label: 'Trademark',            desc: 'Brand registration and renewals' },
  LICENSE:     { label: 'Licenses',             desc: 'MSME, FSSAI and IEC registrations' },
};

export const CATEGORIES_ORDER = [
  'INCOME_TAX','GST','COMPANY','MCA','ACCOUNTING','PAYROLL','TRADEMARK','LICENSE',
];

export const isIncomeTaxService = (code) =>
  SERVICE_CATALOG.find((s) => s.code === code)?.category === 'INCOME_TAX';

/** Deep link to the correct intake form for a catalog service code */
export const serviceFormHref = (serviceCode) =>
  isIncomeTaxService(serviceCode) ? `/file-itr?service=${serviceCode}` : `/get-started?service=${serviceCode}`;

// =============================================================================
// BUSINESS TYPES (for Customer / Get Started form)
// =============================================================================
export const BUSINESS_TYPES = [
  ['MANUFACTURER','Manufacturer'], ['TRADER','Trader'], ['WHOLESALER','Wholesaler'],
  ['RETAILER','Retailer'], ['SERVICE_PROVIDER','Service Provider'], ['WORKS_CONTRACT','Works Contract'],
  ['E_COMMERCE_OPERATOR','E-Commerce Operator'], ['E_COMMERCE_SELLER','E-Commerce Seller'],
  ['ONLINE_SERVICE_PROVIDER','Online Service Provider'], ['SAAS_PROVIDER','SaaS Provider'],
  ['EXPORTER','Exporter'], ['IMPORTER','Importer'], ['EXPORTER_IMPORTER','Exporter & Importer'],
  ['INPUT_SERVICE_DISTRIBUTOR','Input Service Distributor'], ['COMPOSITION_DEALER','Composition Dealer'],
  ['CASUAL_TAXABLE_PERSON','Casual Taxable Person'], ['NON_RESIDENT_TAXABLE_PERSON','Non-Resident Taxable Person'],
  ['SEZ_DEVELOPER','SEZ Developer'], ['SEZ_UNIT','SEZ Unit'],
  ['GOVERNMENT_DEPARTMENT','Government Department'], ['PSU','Public Sector Undertaking (PSU)'],
  ['LOCAL_AUTHORITY','Local Authority'], ['NGO','NGO'], ['TRUST','Trust'], ['SOCIETY','Society'],
  ['EDUCATIONAL_INSTITUTION','Educational Institution'], ['HOSPITAL','Hospital'],
  ['FREELANCER','Freelancer'], ['CONSULTANT','Consultant'], ['CONTRACTOR','Contractor'],
  ['PROFESSIONAL_SERVICES','Professional Services'], ['ADVOCATE','Advocate'], ['DOCTOR','Doctor'],
  ['REAL_ESTATE_DEVELOPER','Real Estate Developer'], ['TRANSPORT_OPERATOR','Transport Operator'],
  ['WAREHOUSE_OPERATOR','Warehouse Operator'], ['AGRICULTURAL_SUPPLIER','Agricultural Supplier'],
  ['MANPOWER_SUPPLIER','Manpower Supplier'], ['OTHER','Other'],
];

// =============================================================================
// STATS, WHY, HERO
// =============================================================================
export const STATS = [
  { value: '10+', label: 'Years Experience' },
  { value: '5000+', label: 'Satisfied Clients' },
  { value: '100%', label: 'Success Rate' },
];
export const EXPERIENCE_STATS = [
  { value: '10+', label: 'Years in Business' },
  { value: '5000+', label: 'Happy Clients' },
  { value: '15000+', label: 'Tax Returns Filed' },
  { value: '500+', label: 'Business Registrations' },
];
export const WHY_CHOOSE = [
  { icon: Users,     title: 'Expert Team',         desc: 'Our team consists of qualified tax agents and tax professionals with years of experience handling complex tax matters.' },
  { icon: Clock,     title: 'Timely Service',      desc: 'We understand deadlines in tax matters and ensure timely completion without compromising quality.' },
  { icon: Sparkles,  title: 'Personalised Approach', desc: 'Customised solutions tailored to your business so you get optimal tax savings.' },
  { icon: BadgeCheck,title: 'Transparent Pricing', desc: 'Upfront, honest pricing with zero hidden charges. You know exactly what you pay.' },
];

// =============================================================================
// MULTILINGUAL REVIEWS (Telugu, Hindi, English) - real-feel Indian clients
// =============================================================================
export const REVIEWS = [
  // Telugu
  { id:'r1', name: 'Ravi Teja Pinnamaneni', city: 'Hyderabad, Telangana', initials: 'RT', lang: 'తెలుగు', langCode: 'te',
    quote: 'మా చిన్న వ్యాపారానికి GST రిజిస్ట్రేషన్ నుండి నెలవారీ ఫైలింగ్ వరకు SolveTax టీం చాలా బాగా చూసుకుంది. ధరలు చాలా సరసమైనవి, స్పందన చాలా త్వరగా ఉంటుంది.',
    service: 'GST Registration & Filing', rating: 5 },
  { id:'r2', name: 'Lakshmi Priya Reddy', city: 'Vijayawada, Andhra Pradesh', initials: 'LP', lang: 'తెలుగు', langCode: 'te',
    quote: 'ITR ఫైలింగ్‌లో నాకు ఎక్కువ రీఫండ్ వచ్చింది. చాలా ప్రొఫెషనల్‌గా పని చేస్తారు. తెలుగులో మాట్లాడటం చాలా సౌకర్యంగా ఉంది.',
    service: 'Income Tax Return Filing', rating: 5 },
  { id:'r3', name: 'Srinivas Garapati', city: 'Visakhapatnam, Andhra Pradesh', initials: 'SG', lang: 'తెలుగు', langCode: 'te',
    quote: 'మా Pvt Ltd కంపెనీ రిజిస్ట్రేషన్ 10 రోజుల్లో పూర్తయింది. ROC ఫైలింగ్స్ కూడా SolveTaxతోనే చేస్తున్నాము. చాలా నమ్మకమైన టీం.',
    service: 'Pvt Ltd Registration', rating: 5 },

  // Hindi
  { id:'r4', name: 'Rahul Sharma', city: 'Delhi NCR', initials: 'RS', lang: 'हिन्दी', langCode: 'hi',
    quote: 'पहली बार ITR ऑनलाइन फाइल करवाया और बहुत आसान अनुभव रहा। टीम ने हर स्टेप पर हिंदी में मार्गदर्शन दिया और रिफंड भी 18 दिन में आ गया।',
    service: 'Income Tax Return Filing', rating: 5 },
  { id:'r5', name: 'Anita Verma', city: 'Lucknow, Uttar Pradesh', initials: 'AV', lang: 'हिन्दी', langCode: 'hi',
    quote: 'मेरे बुटीक के लिए GST रजिस्ट्रेशन और MSME उद्यम दोनों SolveTax ने एक हफ्ते में करवा दिए। दाम भी बिल्कुल वाजिब है। बहुत भरोसेमंद सेवा।',
    service: 'GST + MSME Registration', rating: 5 },
  { id:'r6', name: 'Vikash Kumar Yadav', city: 'Patna, Bihar', initials: 'VK', lang: 'हिन्दी', langCode: 'hi',
    quote: 'इनकम टैक्स विभाग से नोटिस आया था, बहुत डर लग रहा था। SolveTax की टीम ने प्रोफेशनली रिप्लाई बनाया और केस बंद हो गया। हमेशा के लिए भरोसेमंद।',
    service: 'ITR Notice Reply', rating: 5 },

  // English
  { id:'r7', name: 'Aisha Khan', city: 'Mumbai, Maharashtra', initials: 'AK', lang: 'English', langCode: 'en',
    quote: 'Outstanding service! From GST monthly filings to annual returns, the team has been incredibly responsive. Saved me lakhs in penalties last quarter alone. Highly recommended for any growing business.',
    service: 'GST Monthly Filing', rating: 5 },
  { id:'r8', name: 'Joshua Mathew', city: 'Bengaluru, Karnataka', initials: 'JM', lang: 'English', langCode: 'en',
    quote: 'Got my LLP registered through SolveTax in just 9 working days. The process was completely transparent, regular updates over WhatsApp, and zero hidden charges. Perfect for first-time founders.',
    service: 'LLP Registration', rating: 5 },
  { id:'r9', name: 'Pooja Iyer', city: 'Chennai, Tamil Nadu', initials: 'PI', lang: 'English', langCode: 'en',
    quote: 'I had complex capital gains from stocks and ESOPs. SolveTax CAs computed everything accurately, claimed every eligible deduction and filed within 2 hours. Refund credited in 3 weeks.',
    service: 'Capital Gains Filing', rating: 5 },
  { id:'r10', name: 'Karthik Subramaniam', city: 'Pune, Maharashtra', initials: 'KS', lang: 'English', langCode: 'en',
    quote: 'Started my Pvt Ltd through SolveTax and stayed for accounting. Their team handles MCA filings, monthly bookkeeping and payroll seamlessly. Genuine experts who actually pick up calls.',
    service: 'Pvt Ltd + Accounting', rating: 5 },
];

// =============================================================================
// LISTS
// =============================================================================
export const INDIAN_STATES = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Dadra and Nagar Haveli and Daman and Diu','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry',
];
export const LANGUAGES = ['Telugu', 'English', 'Hindi'];

/** Spoken / preferred language `Select` value when the site UI is Telugu (must match an entry in LANGUAGES). */
export const SPOKEN_LANG_FOR_UI_TELUGU = 'Telugu';

/** Default preferred spoken language for forms when `locale === 'te'`; empty when English UI so the user chooses. */
export const defaultSpokenLanguageForUiLocale = (locale) => (
  locale === 'te' && LANGUAGES.includes(SPOKEN_LANG_FOR_UI_TELUGU) ? SPOKEN_LANG_FOR_UI_TELUGU : ''
);
export const SOURCES_OF_INCOME = ['Salary','Business','Profession','House Property','Capital Gains','Other Sources','Multiple Sources'];
export const FINANCIAL_YEARS = ['2024-25','2023-24','2022-23','2021-22','2020-21'];
export const PRIORITIES = [
  { value: 'LOW',    label: 'Low' },
  { value: 'NORMAL', label: 'Normal' },
  { value: 'HIGH',   label: 'High' },
];

// =============================================================================
// SOCIAL LINKS  (replace # with real URLs once provided)
// =============================================================================
export const SOCIAL_LINKS = {
  facebook:  'https://www.facebook.com/share/p/14ZfWMEPk2Y/',
  instagram: 'https://www.instagram.com/solvetax/',
  twitter:   'https://x.com/Solvetax01',
  linkedin:  'https://www.linkedin.com/company/solve-tax/',
  youtube:   '#',
  google:    'https://maps.app.goo.gl/ztVdHda9nmw9Bc5r6',
};

// =============================================================================
// NAV CATEGORIES  (used in mega-menu)
// =============================================================================
export const NAV_CATEGORIES = CATEGORIES_ORDER.map((cat) => ({
  category: cat,
  ...CATEGORY_META[cat],
  services: SERVICE_CATALOG.filter((s) => s.category === cat),
}));

// =============================================================================
// SERVICE GUIDE + PRICING PLACEHOLDER (ready for backend GET integration)
// =============================================================================
// TODO (backend): replace this static map with GET /api/v1/pricing (or similar).
// Keep object shape stable so UI integration remains unchanged.
export const SERVICE_PRICING_PLACEHOLDER = {
  ITR_FILING: 'INR 499 onwards',
  ITR_NOTICE: 'INR 999 onwards',
  ADVANCE_TAX: 'INR 799 onwards',
  CAPITAL_GAINS: 'INR 1999 onwards',

  GST_REGISTRATION: 'INR 999 onwards',
  GST_AMENDMENT: 'INR 699 onwards',
  GST_CANCELLATION: 'INR 799 onwards',
  GST_FILING: 'INR 599 onwards',
  GST_Q_FILING: 'INR 1499 onwards',
  GST_ANNUAL_RETURN: 'INR 1499 onwards',
  GST_LUT: 'INR 499 onwards',
  GST_REFUND: 'INR 1999 onwards',
  GST_NOTICE_REPLY: 'INR 1499 onwards',

  PVT_LTD_REG: 'INR 6999 onwards',
  LLP_REG: 'INR 5999 onwards',
  OPC_REG: 'INR 6499 onwards',
  PARTNERSHIP_REG: 'INR 2499 onwards',

  ROC_ANNUAL: 'INR 2499 onwards',
  DIR3_KYC: 'INR 499 onwards',
  DIRECTOR_CHANGE: 'INR 1499 onwards',

  MONTHLY_ACCOUNTING: 'INR 1999 / month onwards',
  YEAR_END_FINALIZATION: 'INR 4999 onwards',

  PAYROLL_PROCESSING: 'INR 999 / month onwards',
  PF_FILING: 'INR 799 / month onwards',
  ESI_FILING: 'INR 799 / month onwards',

  TRADEMARK_REG: 'INR 1499 onwards',
  TRADEMARK_RENEWAL: 'INR 1999 onwards',

  MSME_REG: 'INR 499 onwards',
  FSSAI_LICENSE: 'INR 1499 onwards',
  IEC_REG: 'INR 999 onwards',
};

const SERVICE_PRICING_RUNTIME = {};

/** Override runtime service prices from backend payment config. */
export const setServicePricingOverrides = (nextPricingMap = {}) => {
  Object.entries(nextPricingMap || {}).forEach(([serviceCode, priceLabel]) => {
    if (!serviceCode || !priceLabel) return;
    SERVICE_PRICING_RUNTIME[serviceCode] = String(priceLabel);
  });
};

export const getServiceStartingPriceValue = (serviceCode) =>
  SERVICE_PRICING_RUNTIME[serviceCode]
  || 'Price on request';

/** One-line “who this is for” per service code (category default is not reused). */
export const SERVICE_BEST_FOR = {
  // GST
  GST_REGISTRATION: '**New businesses** that cross the **GST threshold** or need a **GSTIN** for **B2B**, **e-commerce**, or **interstate supply**.',
  GST_AMENDMENT: '**Registered dealers** updating **legal name**, **principal place**, partners, **HSN**, or other core **GST profile** details.',
  GST_CANCELLATION: 'Businesses **closing down**, falling below threshold, or **no longer liable** who want a proper **GST surrender**.',
  GST_FILING: '**Regular taxpayers** who must file **GSTR-1** and **GSTR-3B** every month with accurate outward and inward data.',
  GST_Q_FILING: '**Small businesses** on the **QRMP scheme** who file **GSTR-1** and **3B quarterly** instead of monthly.',
  GST_ANNUAL_RETURN: 'Businesses that must close the year with **GSTR-9** / **GSTR-9C** and reconciliation to **annual summaries**.',
  GST_LUT: '**Exporters** making **zero-rated supplies** who want to ship without paying **IGST** upfront using a valid **LUT**.',
  GST_REFUND: 'Dealers with **accumulated ITC**, **export refunds**, **inverted duty structure**, or other **refund claims** stuck with the department.',
  GST_NOTICE_REPLY: 'Anyone who received **GST scrutiny**, mismatch (**GSTR-2A**/2B), **ASMT-10**, or **demand notices** and needs a correct reply.',

  // Income tax
  ITR_FILING: '**Salaried employees**, **freelancers**, and **investors** who must file a correct **ITR** and claim **eligible deductions**.',
  ITR_NOTICE: '**Assessees** who received **defective return**, **scrutiny**, or **reassessment notices** and need a strong factual reply.',
  ADVANCE_TAX: 'People with **business**, **professional**, or **capital gains** income who must pay **advance tax** in instalments on time.',
  CAPITAL_GAINS: 'Anyone selling **shares**, **mutual funds**, **property**, or other assets and needs accurate **gain/loss** and reporting.',

  // Company
  PVT_LTD_REG: '**Founders** who want a **private limited company** with **limited liability** and a structure **investors** recognise.',
  LLP_REG: '**Professionals** or **partner groups** wanting **flexible profit-sharing** and lighter compliance than a **private limited**.',
  OPC_REG: '**Solo founders** who want **company status** and **limited liability** without bringing in a second shareholder.',
  PARTNERSHIP_REG: '**Two or more partners** starting a **partnership firm** with a **registered deed** and clear terms.',

  // MCA
  ROC_ANNUAL: '**Private limited companies** and **LLPs** filing yearly financials and **MCA annual returns** (e.g. **AOC-4**, **MGT-7** / **Form 11**).',
  DIR3_KYC: '**Directors** who must complete annual **DIR-3 KYC** so their **DIN** stays active and compliant.',
  DIRECTOR_CHANGE: 'Companies **appointing**, **resigning**, or changing **director details** that must be updated on **MCA records**.',

  // Accounting
  MONTHLY_ACCOUNTING: '**Growing businesses** that want **monthly bookkeeping**, **bank reconciliation**, and **management-ready numbers**.',
  YEAR_END_FINALIZATION: 'Businesses that need **year-end adjustments**, **final accounts**, and statements ready for **audit** or **tax**.',

  // Payroll
  PAYROLL_PROCESSING: '**Employers** who run **monthly payroll** and need compliant **payslips**, **TDS**, and salary-related records.',
  PF_FILING: '**EPF-covered establishments** that must file monthly **ECR**, remit contributions, and keep **PF reconciled**.',
  ESI_FILING: '**ESI-covered units** that must file **monthly contributions** and maintain **employee declarations**.',

  // Trademark
  TRADEMARK_REG: '**New brands** or product lines that need **exclusive rights** to a word, logo, or combination in the right **class**.',
  TRADEMARK_RENEWAL: '**Existing trademark owners** whose **10-year protection** is ending and must **renew** before lapse.',

  // Licenses
  MSME_REG: '**Micro** and **small enterprises** that want official **Udyam registration** for benefits, credit, and eligibility proof.',
  FSSAI_LICENSE: '**Food manufacturers**, processors, retailers, and **cloud kitchens** that need the right **FSSAI licence** for their scale.',
  IEC_REG: '**Importers** and **exporters** who need a valid **IEC** for **customs**, shipping, and **DGFT** filings.',
};

const CATEGORY_GUIDE = {
  INCOME_TAX: {
    bestFor: '**Individuals**, **freelancers**, and businesses needing **tax filing** or **notice support**.',
    timeline: 'Most cases start within **2 hours** after **document review**.',
    documents: '**PAN**, **Aadhaar**, income statements, bank details, and related proofs.',
  },
  GST: {
    bestFor: 'Businesses needing **GST registration**, **filing**, **refunds**, or **notice handling**.',
    timeline: 'Most GST tasks are started within **1 business day**.',
    documents: '**PAN**, **Aadhaar**, business details, **address proof**, and **GST login** data (if applicable).',
  },
  COMPANY: {
    bestFor: '**Founders** setting up or structuring **legal business entities**.',
    timeline: 'Most registrations complete in **7–15 working days**.',
    documents: '**PAN**, **Aadhaar**, **address proof**, business name options, and **partner/director** details.',
  },
  MCA: {
    bestFor: 'Companies managing **ROC annual compliance** and **director updates**.',
    timeline: 'Most filings are prepared in **2–5 working days** after **data collection**.',
    documents: '**CIN**, **DSC**, **director details**, prior filings, and **company financial data**.',
  },
  ACCOUNTING: {
    bestFor: 'Businesses needing **clean books**, **MIS**, and **year-end financial closure**.',
    timeline: 'Monthly workflows start in **1–2 business days**.',
    documents: '**Invoices**, **bank statements**, expense bills, and prior books (**Tally** backup).',
  },
  PAYROLL: {
    bestFor: 'Employers needing **salary processing** and **PF/ESI compliance**.',
    timeline: 'Recurring payroll setup usually starts in **1–3 business days**.',
    documents: '**Employee master**, **salary structure**, **UAN**/ESI data, and attendance inputs.',
  },
  TRADEMARK: {
    bestFor: 'Brands protecting or renewing **business name**/**logo rights**.',
    timeline: '**Application filing** is usually done in **1–3 business days**.',
    documents: '**Applicant details**, **logo**/wordmark, usage details, and **class selection**.',
  },
  LICENSE: {
    bestFor: 'Businesses needing **mandatory registrations** and **operational licences**.',
    timeline: 'Most licence applications are filed in **2–7 business days**.',
    documents: 'Business details, **identity**/**address proofs**, and **sector-specific certificates**.',
  },
};

export const getServiceGuide = (serviceCode) => {
  const svc = SERVICE_CATALOG.find((item) => item.code === serviceCode);
  if (!svc) return null;
  const categoryGuide = CATEGORY_GUIDE[svc.category] || CATEGORY_GUIDE.LICENSE;
  return {
    code: svc.code,
    title: svc.title,
    category: svc.category,
    bestFor: SERVICE_BEST_FOR[svc.code] ?? categoryGuide.bestFor,
    timeline: categoryGuide.timeline,
    documents: categoryGuide.documents,
    startingPrice: getServiceStartingPriceValue(svc.code),
  };
};
